import type { ResourceConfig } from "../types";

/**
 * 学员话题权限配置
 *
 * 仅供 SIO 学员管理自己的网站话题
 */
export const studentTopicConfig = {
  displayName: "我的话题",
  category: "student-topic",
  permissions: {
    "read:own": {
      label: "查看自己的话题",
      description: "SIO 学员可以查看自己的网站话题",
    },
    "write:own": {
      label: "管理自己的话题",
      description: "SIO 学员可以增删改自己的网站话题",
    },
  },
  // 话题管理已移入 SIO Tools，不需要单独导航入口
} satisfies ResourceConfig;
